import ArticleEditor from "../components/ArticleEditor";
import HomePageCMS from "../components/HomePageCMS";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function AssistantDashboard() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12" data-testid="assistant-dashboard">
      <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#7AC143] mb-3">Espace rédacteur</div>
      <h1 className="text-4xl font-black tracking-tighter">Articles & contenu d'accueil</h1>
      <p className="text-[#4B634B] mt-3 max-w-2xl">Créez et publiez des articles pour les Healthy Guides et le Kitchen Corner. Vous pouvez aussi mettre à jour les blocs éditoriaux de la page d'accueil.</p>

      <div className="mt-10">
        <Tabs defaultValue="articles">
          <TabsList>
            <TabsTrigger value="articles" data-testid="assistant-tab-articles">Articles</TabsTrigger>
            <TabsTrigger value="home" data-testid="assistant-tab-home">Page d'accueil</TabsTrigger>
          </TabsList>
          <TabsContent value="articles" className="mt-6">
            <ArticleEditor />
          </TabsContent>
          <TabsContent value="home" className="mt-6">
            <HomePageCMS />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
